import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import * as CryptoJS from 'crypto-js';

import { ProjectsService } from '../../services/projects.service';
import { AlertManagerService } from '../../../../shared/services/alert-manager.service';
import { CookieManagerService } from '../../../../shared/services/cookie-manager.service';

import { Sprint, Story } from '../../../models';
import { Attachment } from '../../../models/attachment';

import { WorkConstants } from "../../work.const";

declare var $: any;

@Component({
  selector: 'app-modal-story-view',
  templateUrl: './modal-story-view.component.html',
})
export class ModalStoryViewComponent implements OnInit {
  @Input() projectId: number;
  @Input() sprintId: number;
  @Input() formData: Array<any>;
  @ViewChild('storyViewModal') elementRef: ElementRef;

  story: Story = new Story();
  isSprints: boolean = false;
  isView: boolean = false;
  authUser: any = {};
  workConstants: any = WorkConstants;

  storyestimateTime: number;
  storyLeftTime: number;
  storySpentTime: number;


  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertManagerService,
    private projectsService: ProjectsService,
    private cookieManagerService: CookieManagerService,
  ) {

  }

  ngOnInit() {
  }

  /**
   * change modal size
   * loaded all sprints
   */
  onOpenModal(story?: Story, view?: boolean) {
    this.isView = true;
    this.getStoryWithTask(story.id, true);
    this.setIsSprints();
    this.getAuthUser();
  }


  /**
   * get task details by task id
   */
  getStoryWithTask(storyId, isShow) {
    this.storyestimateTime = 0;
    this.storyLeftTime = 0;
    this.storySpentTime = 0;
    this.projectsService.getStoryWithTask(storyId).subscribe(
      task => {
        /**
       * Nihara
       * 14/09/2017
       */
        // get sub task estimate, left , spend time count
        task.subTasks.forEach(element => {
          this.storyestimateTime = this.storyestimateTime + parseFloat(element.estimate_time);
          this.storyLeftTime = this.storyLeftTime + parseFloat(element.effort_time_left);
          this.storySpentTime = this.storySpentTime + parseFloat(element.spent_time);
        });

        this.story = task;
        if (isShow) {
          $(this.elementRef.nativeElement).modal({ backdrop: 'static', keyboard: false })
          $(this.elementRef.nativeElement).modal('show');
        }
      }
    );
  }

  /**
   * set sprint id or not 
   */
  setIsSprints() {
    if (this.sprintId < 0) {
      this.isSprints = false;
    } else {
      this.isSprints = true;
      this.story.sprint_id = this.sprintId;
    }
  }

  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }

  getFileExtintion(fileName): string {
    let file = fileName.split('.');
    let extintion = file[file.length - 1]
    return extintion;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/work/modal/modal-story-view/modal-story-view.component.ts